// components/custom_components/ModalHeader.jsx

import {
    Stack,
    Typography,
    IconButton,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const CustomModalHeader = ({
    title = "Modal Title",
    subtitle = "",
    onClose,
}) => {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                mb: 3,
                pb: 2,
                borderBottom: "1px solid #eeeeee",
            }}
        >
            {/* LEFT */}
            <Stack spacing={0.5}>
                <Typography
                    sx={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: "#111",
                        lineHeight: 1.2,
                    }}
                >
                    {title}
                </Typography>

                {subtitle && (
                    <Typography
                        sx={{
                            fontSize: 13,
                            color: "#777",
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Stack>

            {/* CLOSE BUTTON */}
            {onClose && (
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        border: "1px solid #e5e5e5",
                        borderRadius: 1,
                        backgroundColor: "#fff",
                        transition: "all 0.2s ease",

                        "&:hover": {
                            backgroundColor: "#fff1f1",
                            borderColor: "#f3b5b5",
                        },
                    }}
                >
                    <CloseRoundedIcon
                        sx={{
                            fontSize: 18,
                            color: "#555",
                        }}
                    />
                </IconButton>
            )}

        </Stack>
    );
}

export default CustomModalHeader;